import React from 'react';
import CardHeader from '../molecules/CardHeader';
import CardFooter from '../molecules/CardFooter';
import DataPoint from '../molecules/DataPoint';
import Divider from '../atoms/Divider';
import departmentsIcon from '../../public/icons/newspaper.svg';
import workflowsIcon from '../../public/icons/settings.svg';
import fieldsIcon from '../../public/icons/scroll-text.svg';
import formsFilledIcon from '../../public/icons/form.svg';

/**
 * System / template card organism.
 *
 * Props are data-only so the parent app owns API & auth.
 */
export default function SystemCard({
  id,
  title,
  item,
  status = 'inactive',
  statusLabel,
  description,
  descriptionHref,
  departments,
  workflows,
  fields,
  formsFilled,
  updatedOn,
  titleAsLink = false,
  onTitleClick,
  onDescriptionClick,
  onConfigure,
  onOpen,
  menuOptions = [],
  className = '',
}) {
  const   handleConfigure = () => {
    onConfigure?.({
      id,
      title,
      status,
      departments,
      workflows,
      fields,
      formsFilled,
      updatedOn,
    });
  };

 

  const handleDescription = () => {
    if (onDescriptionClick) {
      onDescriptionClick({ id, title, descriptionHref });
      return;
    }
    if (descriptionHref && typeof window !== 'undefined') {
      window.open(descriptionHref, '_blank', 'noopener,noreferrer');
    }
  };

  const stats = [
    { label: 'Total entries', value: item?.totalEntries, icon: <img src={departmentsIcon} alt="" /> },
    { label: 'Open entries', value: item?.openEntries, icon: <img src={workflowsIcon} alt="" /> },
    { label: 'Closed entries', value: item?.closedEntries, icon: <img src={fieldsIcon} alt="" /> },
    { label: 'Escalated entries', value: item?.escalatedEntries, icon: <img src={formsFilledIcon} alt="" /> },
  ];

  // console.log(JSON.stringify(item) + "....");

  return (
    <article className={`ca-system-card ${className}`.trim()}>
      <CardHeader
        title={item?.name}
        status={item?.isActive ? 'active' : 'inactive'}
        statusLabel={statusLabel}
        titleAsLink={titleAsLink}
        onTitleClick={() => onTitleClick?.({ id, title })}
        menuOptions={menuOptions}
      />

      {description ? (
        <p className="ca-system-card__description" onClick={handleDescription}>{description}</p>
      ) : null}

      <div className="ca-system-card__stats">
        {stats.map((stat, index) => (
          <React.Fragment key={stat.label}>
            {index > 0 ? <Divider /> : <div className="ca-system-card__stats-spacer" />}
            <DataPoint label={stat.label} value={stat.value} icon={stat.icon} />
          </React.Fragment>
        ))}
      </div>

      <CardFooter
        updatedOn={updatedOn}
        onOpen={() => onOpen?.({ id, title })}
        id={id}
        title={title}
        onConfigure={handleConfigure}
      />
    </article>
  );
}
